<template lang="pug">
.colorbar-careers-people(id="people-traits")
  .row.full-width.traits
    .peopleHeading
      h2.f-secondary.xs-f-grande.md-f-xxxgrande.max-at-tweak {{ title }}
      h3.f-primary.xs-f-large.max-at-tweak {{ subtitle }}
    .row.full-width.xs-hide
      slick.traitSlides(ref="traitSlidesCarousel" v-bind="carouselConfig" @beforeChange="handleSlideChange")
        .traitContainer(v-for="trait in traits" :key="trait.title")
          .trait-wrapper.md-6
            .trait
              .inner-trait
                h2.the-title.f-secondary.upper.xs-f-xxlarge.max-at-tweak {{ trait.title }}
                p.the-subtitle.f-primary.xs-f-medium.max-at-tweak {{trait.subtitle}}
          .image-wrap.md-6
            responsive-image.peoplePic(:media-obj="trait.image" xs-aspect-key="4x3")
    .row.sm-hide.md-hide.lg-hide(v-cloak)
      slick.quotesCarousel(ref="quotesCarousel" v-bind="blindCarouselConfig" @beforeChange="onBeforeChange($refs.quotesCarousel, ...arguments)")
        .traitContainer(v-for="trait in traits" :key="trait.title")
          .trait-wrapper
            .trait
              h2.the-title.f-secondary.upper.xs-f-xxlarge.max-at-tweak {{ trait.title }}
              p.the-subtitle.f-primary.xs-f-medium.max-at-tweak {{trait.subtitle}}
      .row
        slick.dotsCarousel(ref="dotsCarousel" v-bind="{...carouselConfig}" @beforeChange="onBeforeChange($refs.dotsCarousel, ...arguments)")
          div(v-for="trait in traits" :key="trait.title")
      .row
        slick.imagesCarousel(ref="imagesCarousel" v-bind="blindCarouselConfig" @beforeChange="onBeforeChange($refs.imagesCarousel, ...arguments)")
          .traitContainer(v-for="trait in traits" :key="trait.title")
            .image-wrap.xs-12
              responsive-image.peoplePic(:media-obj="trait.image" xs-aspect-key="4x3")
</template>

<script>
  export default {

    name: 'HcbCareersTraits',

    props: {
      title: {
        type: String,
        default: ''
      },
      subtitle: {
        type: String,
        default: ''
      },
      traits: {
        type: Array,
        default() {
          return [];
        }
      }
    },

    computed: {
      carouselConfig() {
        return {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          draggable: false,
          focusOnSelect: false,
          autoplay: false
        };
      },

      blindCarouselConfig() {
        return {
          ...this.carouselConfig,
          dots: false,
          arrows: false
        };
      },
    },

    mounted() {
      this.startUpButtonsListeners();
    },

    methods: {
      onBeforeChange(currentCarousel, currentPosition, nextPosition) {
        [this.$refs.quotesCarousel, this.$refs.dotsCarousel, this.$refs.imagesCarousel, this.$refs.traitSlidesCarousel]
          .filter(carousel => carousel !== currentCarousel && carousel.$refs.innerSlider.currentSlide !== nextPosition)
          .forEach(carousel => carousel.goTo(nextPosition));
      },

      startUpButtonsListeners() {
        this.$refs.traitSlidesCarousel.$el.querySelectorAll('.traitSlides .slick-dots button').forEach((button, index) => {
          button.addEventListener('click', event => this.setLineToButton(event.currentTarget));

          if (index === 0) {
            // Initializating the line
            button.classList.add('purpleLine');
          }

          button.textContent = this.traits[index].title;
        });
      },
      
      setLineToButton(button) {
        this.$refs.traitSlidesCarousel.$el.querySelectorAll('.purpleLine').forEach(element => element.classList.remove('purpleLine'));
        button.classList.add('purpleLine');
      },

      handleSlideChange(currentSlide, nextSlide) {
        this.$refs.traitSlidesCarousel.$el.querySelectorAll('.traitSlides .slick-dots button').forEach((button, index) => {
          if (nextSlide === index) {
            this.setLineToButton(button);
          }
        });
      },
    },
  };
</script>

<style lang="stylus" scoped>
.colorbar-careers-people
  .full-width
    max-width 100%
    width 100%

  .traits
    background-color #EAE8E9
    
    .peopleHeading
      font-family "Kapra-Regular", sans-serif
      text-transform uppercase
      font-size 3.625rem
      line-height 56px
      color text-color-1

      letter-spacing 0
      text-align center
      margin 5.9375rem 0 6.6875rem
      
      @media (max-width 1024px)
        margin 3.1875rem 0 1.875rem
      
      @media mq-desktop-md-less
        font-size 2.625rem

    .dotsCarousel
      @media mq-desktop-md-less
        margin-bottom 15px

      :deep(.slick-dots)
        display flex !important
        justify-content space-around
        transform translate(-50%, 50%)
        margin-right -50%
        left 50%

        @media mq-desktop-less
          top -72px
          display unset !important

        li
          button
            font-size 0
            border none
            margin -6px
          
            &:before
              width 8px
              height 8px
              border 0px solid #ffffff
              border-radius 100px
              opacity 1
              content ''
              background-color #c4c4c4

            &:focus
              outline none

        .slick-active button
          &:before
            background-color #600057

    .traitSlides, .quotesCarousel, .imagesCarousel
      margin-bottom -3px

      @media mq-desktop-md-tweak-lower
        margin-top 40px

      .traitContainer
        align-items center
        position relative
        margin-bottom 0px
        
        .image-wrap
          position relative
          display block
          height 101%
          float left
          overflow hidden

          .peoplePic
            :deep(img)
              height 100%
              width inherit

          @media mq-mobile-less
            margin-left unset

            .peoplePic
              :deep(img)
                width 100%

        .trait-wrapper
          position relative
          height 100%
          float left
    
          .trait
            transform translateY(-50%)
            position relative
            margin-top 50%
            margin-left 35%
            
            .inner-trait
              transform translateY(-75%)

            .the-title
              color brand-color-3

              margin-bottom 1.25rem
              letter-spacing 0
              text-align left
            
            .the-subtitle
              color color-mister-darker-gray
              text-transform none

              letter-spacing 0
            
            @media mq-tablet-less
              margin-left 0%
              transform unset
              margin-top 0%
              padding-left 6px
              padding-right 6px
              text-align center

              .the-title
                text-align center

              .the-subtitle
                margin-bottom 1.25rem

      :deep(.slick-dots)
        display flex !important
        justify-content space-around
        transform translate(-50%, 50%)
        margin-right -50%
        left 50%

        li
          button
            font-size 0
            border none
            margin -6px
          
            &:before
              width 8px
              height 8px
              border 0px solid #ffffff
              border-radius 100px
              opacity 1
              content ''
              background-color #c4c4c4

            &:focus
              outline none

        .slick-active button
          &:before
            background-color cta-color-2
          
        @media mq-tablet-plus
          width 600px
          bottom 100%
          padding-bottom 70px

          li
            height auto
            width auto
            text-align center

            button
              background-color transparent !important
              margin 0px
              font-family f-primary
              font-size 1.25rem
              color #535353
              text-transform uppercase

              letter-spacing 0.9px
              line-height 30px
              text-align center

              width unset
              height unset

              &:before
                background-color transparent !important
                content '' !important
          
          .purpleLine
            border-bottom 6px solid brand-color-3

</style>